import { Box, Stack } from '@mui/material';
import { translate } from '../../i18n'
import { getFacilityLotteryReservationCancelSteps } from '../../containers/common/codeMaster';
import { facilityLotteryReservationCancelStep } from '../../containers/common/constant/classification';
import { useAction } from '../../containers/facilityLotteryReservationCancelConfirmation/facilityLotteryReservationCancelConfirmationService'
import LotteryReservationDetailGItems from '../components/common/lotteryReservationDetail/lotteryReservationDetailGItems';
import { BottomButtonGroup } from '../components/common/bottomButtonGroup'
import { BackButton } from '../components/common/buttons/backButton'
import { ButtonOutlinedWarningL } from '../components/common/buttons/buttonOutlinedWarningL'
import { ErrorMessageCard } from '../components/common/errorMessageCard'
import { GContainer, GItem, RowSpacerGItem } from '../components/common/grids'
import { InfoCard } from '../components/common/infoCard'
import { LabelGItem, ValueGItem } from '../components/common/reservationDetail/reservationDetailParts'
import { StepBar } from '../components/common/stepBar'
import { TransitionCheck } from '../components/common/transitionCheck'

export const FacilityLotteryReservationCancelConfirmation = () => {
  const { lotteryReservation, deleteResultCode, reservationDetail, showSiblingsLotteryResultReferenceFlag, decide } = useAction();
  
  if (!lotteryReservation) {
    return <TransitionCheck check={false} />
  }

  if (!reservationDetail) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <Box>
        <GContainer>
          <GItem md={3}></GItem>
          <GItem xs={12} md={6}>
            <Stack spacing={2}>
              <StepBar
                activeStepValue={facilityLotteryReservationCancelStep.step1}
                stepValueLabels={getFacilityLotteryReservationCancelSteps()}
              />

              <InfoCard>
                <GContainer>
                  <LabelGItem>{translate('facilityLotteryReservationCancelConfirmation.label.cancelReason')}</LabelGItem>
                  <ValueGItem>{lotteryReservation.cancelReason.stringify}</ValueGItem>
                  <RowSpacerGItem />

                  <LotteryReservationDetailGItems 
                    lotteryReservation={reservationDetail} 
                    useReason={reservationDetail.useReason} 
                    displayType="delete"
                    showSiblingsLotteryResultReferenceFlag={showSiblingsLotteryResultReferenceFlag}
                  />
                </GContainer>
              </InfoCard>

              {!!deleteResultCode && (
                <ErrorMessageCard
                  messages={[
                    translate(`facilityLotteryReservationCancelConfirmation.error.deleteResultCode${deleteResultCode}`),
                  ]}
                />
              )}
            </Stack>
          </GItem>
          <GItem md={3}></GItem>
        </GContainer>
      </Box>
      <BottomButtonGroup>
        <ButtonOutlinedWarningL fullWidth onClick={decide}>
          {translate('facilityLotteryReservationCancelConfirmation.button.decision')}
        </ButtonOutlinedWarningL>
        <BackButton />
      </BottomButtonGroup>
    </Stack>
  )
}
